import React, { useState } from 'react';
import productImage from '../assets/product_image.png';
import { Button, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import '../styles/components/ProductDetails.scss';
import cart from '../assets/icons/cart.svg';
import CategoryCard from './CategoryCard';
import ProceedToBuyPopup from '../../User/components/ProceedToBuyPopup';
import FabricPopup from './FabricPopup';
import YesFabricPopup from './YesFabricPopup';
import Image from '../../Utils/getImage';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";
import instance from '../../Utils/api';
import { useNavigate } from 'react-router-dom';


const ProductDetails = ({ data }) => {
    //proceed to buy popup
    const [isProceed, setIsProceed] = useState(false)
    const handleProceedOpenModal = () => setIsProceed(true);
    const handleProceedCloseModal = () => setIsProceed(false);
    //fabric popup
    const [isFabric, setIsFabric] = useState(false)
    const handleFabricOpenModal = () => setIsFabric(true);
    const handleFabricCloseModal = () => setIsFabric(false);
    const [recommended, setRecommended] = useState();
    const navigate = useNavigate();
    
    const getRecommended = async () => {
        try {
            const response = await instance.get(
                `/Common/recommendedDesigns?size=10`
            );
            setRecommended(response?.data?.data);
        } catch (err) {
            console.log(err);
        }
    };
    useState(() => {
        getRecommended();
    }, []);

    return (
        <React.Fragment>
            <section className='product-details'>
                <Container maxWidth='xl'>
                    <Grid spacing={4} container sx={{
                        display: 'flex',
                        alignItems: {
                            xs: 'flex-start',
                            sm: 'center',
                            md: 'center',
                            lg: 'center'
                        },
                    }}>
                        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            {/* <div className='product-image'>
                                <Image src={data?.picture[0]} alt='product Image' height={400} width={420} />
                            </div> */}
                            <section className="product-image">
                                <Swiper
                                    spaceBetween={30}
                                    // centeredSlides={true}
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: true,
                                    }}
                                    modules={[Autoplay, Pagination]}
                                    loop={true}
                                    pagination={{
                                        clickable: true,
                                    }}
                                >
                                    {data && data.picture.length > 0 ? (
                                        data.picture.map((pictureUrl, index) => (
                                            <SwiperSlide key={index}>
                                                {pictureUrl ? (
                                                    <div className="Banner_images">
                                                        <Image
                                                            src={pictureUrl}
                                                            alt={data?.name || "Banner"}
                                                            layout="responsive"
                                                            width={420}
                                                            height={400}
                                                        />
                                                    </div>
                                                ) : (
                                                    <p>No image available</p>
                                                )}
                                            </SwiperSlide>
                                        ))
                                    ) : (
                                        <p>No banners available</p>
                                    )}
                                </Swiper>
                            </section>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
                            <div className='product-details-content'>
                                <Typography variant='h2'>{data?.name || "---"}</Typography>
                                <div className='product-description'>
                                    <Typography>{data?.description || "---"}</Typography>
                                </div>
                                <div className='product-price'>
                                    <Typography>Price:  <strong>Starts from ₹{data?.price || "---"}</strong></Typography>
                                </div>
                                <div className='products-btn'>
                                    <Button className='add-product-btn' onClick={handleFabricOpenModal}><img src={cart} alt='cartimage' />Add to cart</Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            <section className='products-recommended'>
                <Container maxWidth='xl'>
                    <div className='recommended-title'>
                        <Typography variant='h5'>Recommended</Typography>
                        <Button>view all</Button>
                    </div>
                    <div className='recommended-image'>
                        <Grid container spacing={2}>
                            {recommended?.map((data, item) => (
                                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                                    <CategoryCard
                                        image={data?.picture[0]}
                                        title={data?.name}
                                        onclick={() => {
                                            navigate(`/product/${data._id}`);
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </Container>
            </section>
            <ProceedToBuyPopup isProceed={isProceed} handleProceedCloseModal={handleProceedCloseModal} />
            {/* <FabricPopup isFabric={isFabric} handleFabricCloseModal={handleFabricCloseModal} /> */}
            <YesFabricPopup isYesFabric={isFabric} handleYesFabricCloseModal={handleFabricCloseModal} add_to_cart={true} />

        </React.Fragment>

    )
}

export default ProductDetails